import { Dashboard } from './dashboard.component';
import { withStatistics } from '../../common/components/with-statistics.container';

export { Dashboard };
export const DashboardContainer = withStatistics(Dashboard);
